<template>
	<section>
		<ButtonBack />

		<h1>Fälle</h1>

		<h2>Filter</h2>
		<TheForm :model="request" :rules="rules" :id="id" ref="formRef" :persistForm="true" formNamespace="faelleVorstandFilter" :autoSave="true">
			<el-row>
				<el-form-item label="Freitextsuche" prop="searchTerm" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
					<el-input v-model="request.searchTerm" placeholder="Suche" clearable />
				</el-form-item>

				<el-col :sm="12" :xs="24">
					<el-row>
						<el-form-item label="Beschwerdegrund" prop="category" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
							<el-select v-model="request.category" placeholder="Alle">
								<el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
						<el-form-item label="Medium" prop="medium" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
							<el-select v-model="request.medium" placeholder="Alle">
								<el-option v-for="item in mediaOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
					</el-row>
				</el-col>
			</el-row>

			<el-row>
				<el-col :sm="12" :xs="24">
					<el-row>
						<el-form-item label="Branche" prop="sector" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
							<el-select v-model="request.sector" placeholder="Alle">
								<el-option v-for="item in sectorOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
						<el-form-item label="Bundesland" prop="reach" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
							<el-select v-model="request.reach" placeholder="Alle">
								<el-option v-for="item in reachOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
					</el-row>
				</el-col>

				<el-col :sm="12" :xs="24">
					<el-row>
						<el-form-item label="Status" prop="states" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
							<!-- TODO: Soll noch multiselect werden können -->
							<el-select v-model="request.states" placeholder="Alle">
								<el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
						<el-form-item label="Veröffentlicht" prop="isPublished" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
							<el-select v-model="request.isPublished" placeholder="Alle">
								<el-option v-for="item in isPublicOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
					</el-row>
				</el-col>
			</el-row>

			<el-row>
				<el-form-item label="Zeitraum (Erstellung)" prop="timePeriod" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
					<el-checkbox-group v-model="selectedTimePeriod">
						<el-checkbox
							v-for="item in timePeriodOptions"
							:key="item.value"
							:value="item.value"
							:border="true"
							@change="() => handleClickOptionWrapper(item)"
						>
							{{ item.label }}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-col :sm="4" :xs="24"></el-col>
				<el-form-item label="" prop="dateRange" class="el-col el-col-24 el-col-sm-8 el-col-xs-24">
					<div class="datepicker-range__labels">
						<label class="el-form-item__label">Von</label>
						<label class="el-form-item__label">Bis</label>
					</div>
					<el-date-picker
						v-model="dateRange"
						type="daterange"
						:format="'DD.MM.YYYY'"
						range-separator=""
						:clearable="true"
						start-placeholder="TT.MM.JJJJ"
						end-placeholder="TT.MM.JJJJ"
					/>
				</el-form-item>
			</el-row>
			<el-row class="button-panel">
				<TheButton
					type="danger"
					@buttonclick="
						tablePage = 0;
						doSearch();
					"
					isSubmit
					>Anwenden</TheButton
				>
				<TheButton type="default" @buttonclick="resetSearch">
					<el-icon><Close /></el-icon>
					Filter zurücksetzen
				</TheButton>
			</el-row>
		</TheForm>
	</section>

	<div class="bg--white">
		<section id="searchresults" v-if="isMobile">
			<el-row class="flex flex--aligncenter">
				<el-col :span="22">
					<h2 class="no-margin">Fälle ({{ $getCountErgebnisseLabel(casesTotalCount) }})</h2>
				</el-col>
				<el-col :span="2" class="flex flex--justifyend">
					<SortIcon class="sorticon" @click="openTableSortDrawer = true" />
				</el-col>
			</el-row>

			<CasesTable
				:tableData="filteredCases"
				:loading="casesTableLoading"
				:totalCount="casesTotalCount"
				@loadNextPage="loadNextPage"
				:mobileBox="true"
				:sort="tableSort"
			/>
			<TableSortDrawer v-model:open="openTableSortDrawer" :currentSort="tableSort" @setSort="(sort) => (tableSort = sort)" />
		</section>
		<section id="searchresults" v-else>
			<h2>Fälle ({{ $getCountErgebnisseLabel(casesTotalCount) }})</h2>
			<CasesTable :tableData="filteredCases" :loading="casesTableLoading" :totalCount="casesTotalCount" @loadNextPage="loadNextPage" />
		</section>
	</div>
</template>

<script lang="ts">
import ButtonBack from '@/components/buttons/ButtonBack.vue';
import CasesTable from '@/components/tables/CasesTable.vue';
import TheButton from '@/components/TheButton.vue';
import TheForm from '@/components/TheForm.vue';
import { searchCases } from '@/requests/searches.js';
import { CaseResponse, CaseState, SearchCaseRequest, TableSort } from '@/types/types';
import { returnFormOptions } from '@/utils/formOptions.js';
import { handleClickTimePeriodOptionCheckbox, handleSearchDateRangeChange, prepareSearchRequest } from '@/utils/search/searchUtils';
import { validateForm, resetForm } from '@/utils/functions';
import { Close, Plus } from '@element-plus/icons-vue';
import { FormInstance } from 'element-plus';
import { defineComponent, ref, computed } from 'vue';
import { texts } from '../utils/texts';
import SortIcon from '../assets/icons/SortIcon.vue';
import TableSortDrawer from '../components/TableSortDrawer.vue';
import { useStore } from '../store';

interface SearchCasesData {
	request: SearchCaseRequest;
	rules: Object;
	id: string;
	dateRange: string[] | null;
	selectedTimePeriod: any[];
	tablePage: number;
	itemsPerPage: number;
	filteredCases: CaseResponse[];
	casesTotalCount: number;
	casesTableLoading: boolean;
	defaultDoneStates: CaseState[];
	openTableSortDrawer: boolean;
	tableSort: TableSort;
}

export default defineComponent({
	name: 'FaelleVorstandView',
	data(): SearchCasesData {
		return {
			request: {
				searchTerm: '',
				category: null,
				medium: null,
				states: null,
				isPublished: null,
				fromDate: null,
				toDate: null,
				reach: null,
				sector: null,
			},
			rules: {
				searchTerm: [{ min: 3, message: texts.formErrors.minChars, trigger: 'blur' }],
			},
			id: 'searchForm',
			dateRange: null,
			selectedTimePeriod: [],
			tablePage: 0,
			itemsPerPage: 14,
			filteredCases: [],
			casesTotalCount: 0,
			casesTableLoading: false,
			defaultDoneStates: [
				CaseState.DecisionNoReason,
				CaseState.DecisionSensitization,
				CaseState.DecisionStop,
				CaseState.NotResponsible,
				CaseState.ProcedureNotPossible,
				CaseState.Unfounded,
			],
			openTableSortDrawer: false,
			tableSort: { prop: 'voteEndDate', order: 'ascending' } as TableSort, // Current sort option
		};
	},
	setup() {
		const store = useStore();
		const formRef = ref<FormInstance>();
		const isMobile = computed(() => store.state.isMobile);
		return {
			formRef,
			isMobile,
		};
	},
	components: {
		ButtonBack,
		TheButton,
		TheForm,
		Plus,
		Close,
		CasesTable,
		SortIcon,
		TableSortDrawer,
	},
	computed: {
		categoryOptions() {
			return returnFormOptions('complaintAndCaseCategories', false, true);
		},
		mediaOptions() {
			return returnFormOptions('media', false, true);
		},
		sectorOptions() {
			return returnFormOptions('sector', false, true);
		},
		reachOptions() {
			return returnFormOptions('reach', false, true);
		},
		statusOptions() {
			return returnFormOptions('caseStateOptions', false, true).filter((option: any) => {
				if (option.label === 'Alle') return true;
				return this.defaultDoneStates.some((state) => state === option.value);
			});
		},
		isPublicOptions() {
			return returnFormOptions('isPublic', false, true);
		},
		timePeriodOptions() {
			return returnFormOptions('timePeriod');
		},
	},
	methods: {
		handleClickOptionWrapper(item) {
			const { newSelectedTimePeriod, newTimePeriodOptions, newDateRange } = handleClickTimePeriodOptionCheckbox(
				item,
				this.selectedTimePeriod,
				this.timePeriodOptions,
			);

			this.selectedTimePeriod = newSelectedTimePeriod;
			this.timePeriodOptions = newTimePeriodOptions;
			this.dateRange = newDateRange;
		},
		resetSearch() {
			resetForm(this.formRef, this.id);
			this.dateRange = null;
			this.tablePage = 0;
			this.doSearch();
		},
		async doSearch() {
			const isValid = await validateForm(this.formRef, this.id);
			if (!isValid) return;

			this.casesTableLoading = true;
			let searchRequest = prepareSearchRequest(this.request) as SearchCaseRequest;

			if (!searchRequest.states) {
				searchRequest.states = this.defaultDoneStates;
			} else {
				//@ts-ignore
				searchRequest.states = [searchRequest.states];
			}

			const searchResult = await searchCases(searchRequest, this.tablePage, this.itemsPerPage);
			if (searchResult.success) {
				this.casesTotalCount = searchResult.data.totalCount;
				if (this.tablePage === 0) {
					this.filteredCases = searchResult.data.items;
				} else {
					this.filteredCases = [...this.filteredCases, ...searchResult.data.items];
				}
			} else {
				this.filteredCases = [];
				this.casesTotalCount = 0;
			}
			this.casesTableLoading = false;
		},
		loadNextPage() {
			this.tablePage++;
			this.doSearch();
		},
	},
	mounted() {
		if (this.$route.query.searchTerm) {
			this.request.searchTerm = String(this.$route.query.searchTerm);
		}
		this.doSearch();
	},
	watch: {
		dateRange: {
			handler(val) {
				if (val && val.length === 2) {
					const { fromDate, toDate } = handleSearchDateRangeChange(val);
					this.request.fromDate = fromDate;
					this.request.toDate = toDate;
				} else {
					this.request.fromDate = null;
					this.request.toDate = null;
					this.selectedTimePeriod = [];
					this.timePeriodOptions.forEach((option: any) => (option.checked = false));
				}
			},
			deep: true,
		},
		request: {
			handler() {
				if (this.request.fromDate && this.request.toDate) {
					this.dateRange = [this.request.fromDate, this.request.toDate];
				}
			},
			deep: true,
		},
	},
});
</script>
